import React from 'react';
import { PropTypes } from 'prop-types';
import createSvgIcon from '../createSvgIcon';

const ThumbsUp = ({
  variant
}) => {
  const solid = /*#__PURE__*/React.createElement("path", {
    d: "M52.46,23.68 L42.85,23.68 L42.85,8.28 C42.85,7.44 42.46,7 41.63,7 L35,7 C34,10 32.29,14.85 30.81,16.32 L29.42,17.71 C25.6,21.53 21.86,23.71 18.42,23.71 L6.28,23.71 C5.45,23.71 5,24.09 5,24.92 L5,56.63 C5,57.46 5.45,57.84 6.28,57.84 L40,57.84 C54,57.61 59,53.73 59,37.84 L59,32.92 C59,26.04 57.31,23.68 52.46,23.68 Z M13,53.84 L9,53.84 L9,27.69 L13,27.69",
    "data-name": "Laag 1"
  });
  const outline = /*#__PURE__*/React.createElement("path", {
    d: "M52.46,23.68 L42.85,23.68 L42.85,8.28 C42.85,7.44 42.46,7 41.63,7 L35,7 C34,10 32.29,14.85 30.81,16.32 L29.42,17.71 C25.6,21.53 21.86,23.71 18.42,23.71 L6.28,23.71 C5.45,23.71 5,24.09 5,24.92 L5,56.63 C5,57.46 5.45,57.84 6.28,57.84 L40,57.84 C54,57.61 59,53.73 59,37.84 L59,32.92 C59,26.04 57.31,23.68 52.46,23.68 Z M13,53.84 L9,53.84 L9,27.69 L13,27.69 L13,53.84 Z M55,37.84 C55,50.54 51,53.65 39.82,53.84 L17,53.84 L17,27.69 L18.42,27.69 C22.58,27.76 26.8,25.94 30.72,22.08 L30.72,22.08 L32.38,20.42 L32.38,20.42 C34.0436366,18.7772154 35.4254498,16.8717321 36.47,14.78 L36.56,14.59 L37.83,11.01 L38.83,11.01 L38.83,27.69 L51.29,27.69 C54,27.68 55,29.02 55,32.92 L55,37.84 Z",
    "data-name": "Laag 1"
  });
  const iconType = variant === 'solid' ? solid : outline;
  const Icon = createSvgIcon({
    title: 'Report',
    width: '25px',
    height: '25px',
    viewBox: '0 0 64 64',
    content: iconType
  });
  return /*#__PURE__*/React.createElement(Icon, null);
};

ThumbsUp.propTypes = {
  variant: PropTypes.oneOf(['outline', 'solid'])
};
export default ThumbsUp;